import { setupModeColors } from "../../SetupMode/colors";
import { css } from "@linaria/core";

export const setupCommentEditor = css`
  & > .editable:not(.error):focus-within {
    border-color: ${setupModeColors.primary};
  }
`;
